import React, { useMemo } from 'react';
import styles from './Text.module.scss';
import classNames from 'classnames';

export const textVariantsEnum = {
  Display_2xl: 'Display_2xl',
  Display_xl: 'Display_xl',
  Display_lg: 'Display_lg',
  Display_md: 'Display_md',
  Display_sm: 'Display_sm',
  Display_xs: 'Display_xs',
  Header: 'Header',
  Text_25: 'Text_25',
  Text_15: 'Text_15',
  Text_xl: 'Text_xl',
  Text_lg: 'Text_lg',
  Text_md: 'Text_md',
  Text_sm: 'Text_sm',
  Text_13: 'Text_13',
  Text_xs: 'Text_xs',
  Text_xxs: 'Text_xxs',
  Text_5: 'Text_5',
};
export const fontWeightEnum = {
  Normal: 'Normal',
  Medium: 'Medium',
  Semibold: 'Semibold',
  Bold: 'Bold',
  Light: 'Light',
};
const htmlTagMapping = {
  Display_2xl: 'h1', // 72px
  Display_xl: 'h2', // 60px
  Display_lg: 'h3', // 48px
  Display_md: 'h4', // 36px
  Display_sm: 'h5', // 30px
  Display_xs: 'h6', // 24px

  Text_25: 'p', // 25px
  Header: 'p', // 22px
  Text_xl: 'p', // 20px
  Text_lg: 'p', // 18px
  Text_15: 'p', // 15px
  Text_md: 'p', // 16px
  Text_sm: 'p', // 14px
  Text_13: 'p', // 13px
  Text_xs: 'p', // 12px
  Text_xxs: 'p', // 10px
  Text_5: 'p', // 5px
};
export const TextComponent = ({
  id,
  children,
  className,
  color,
  fontWeight,
  style,
  variant,
  onClick,
}) => {
  const HtmlTag = htmlTagMapping[variant];
  const textClass = classNames(className, styles.text, {
    [styles[`text_type_${variant}`]]: variant,
    [styles[`text_fontWeight_${fontWeight}`]]: fontWeight,
    [styles[`text_cursor`]]: onClick,
  });
  const textStyles = useMemo(() => {
    const colorStyle = color ? { color: `var(--${color})` } : {};
    return { ...colorStyle, ...style };
  }, [style, color]);

  return (
    <HtmlTag className={textClass} onClick={onClick} style={textStyles} id={id}>
      {children}
    </HtmlTag>
  );
};
